(function () {
    'use strict';

    const cfg = window.__SCREENSAVER_CONFIG__ || {};
    const root = document.getElementById('screensaver');
    if (!root || !cfg.idleSeconds) return;

    const idleMs = Math.max(5, cfg.idleSeconds) * 1000;

    let idleTimer = null;
    let isActive = false;

    /* ---------- Attivazione / disattivazione ---------- */
    function activate() {
        if (isActive) return;
        isActive = true;
        root.classList.add('is-visible');
        root.setAttribute('aria-hidden', 'false');
        document.body.classList.add('screensaver-active');
    }

    function deactivate() {
        if (!isActive) return;
        isActive = false;
        root.classList.remove('is-visible');
        root.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('screensaver-active');
    }

    /* ---------- Gestione inattività ---------- */
    function resetIdleTimer() {
        if (isActive) deactivate();
        clearTimeout(idleTimer);
        // Riavvia il timer solo se la tab è visibile, così non parte
        // mentre l'utente sta guardando un'altra scheda
        if (document.visibilityState === 'visible') {
            idleTimer = setTimeout(activate, idleMs);
        }
    }

    /* ---------- Eventi che indicano "utente vivo" ---------- */
    const activityEvents = [
        'mousemove',
        'mousedown',
        'keydown',
        'wheel',
        'scroll',
        'touchstart',
        'touchmove',
        'pointerdown',
    ];

    activityEvents.forEach(ev => {
        window.addEventListener(ev, resetIdleTimer, { passive: true });
    });

    // Click sullo screensaver = chiudilo subito
    root.addEventListener('click', resetIdleTimer);
    root.addEventListener('touchstart', resetIdleTimer, { passive: true });

    /* ---------- Page Visibility API ----------
       Quando la tab non è visibile:
       - fermiamo il timer (lo screensaver non parte in background)
       - se è già attivo, l'animazione CSS del glow continua, ma il browser
         la sospende automaticamente perché il rendering è fermo
    */
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            resetIdleTimer();
        } else {
            clearTimeout(idleTimer);
        }
    });

    // Avvio
    resetIdleTimer();
})();